import React from "react"
import FAQ from "../../design-system/organisms/faq-section"

const FAQItems = [
  {
    title: "How do indoor maps help with facilities management?",
    text: (
      <>
        <span>
          Indoor mapping platforms have become a crucial tool for facility
          managers. Because facilities management can get complicated
          particularly in large venues, it’s important to have an indoor map
          that allows you to create a clear visualization of the building
          environment. A reliable indoor mapping system transforms a building
          CAD to an interactive map to help building owners and facility
          managers manage building plans, spaces, and resources, as well as
          optimizing operational workflows. Resource planning also becomes
          easier with real-time location data indoors, so facilities teams can
          implement new crowd control rules, meeting room booking systems, or
          uncover unused space. Insights and analytics provide a clear analysis
          of how your space is being used.
        </span>
        <span>
          {" "}
          With indoor positioning systems, you can keep track of all building
          facilities by leveraging positioning technology to pinpoint places or
          objects that require maintenance and equipment that may need
          repairing. Facilities managers are also able to map out safety routes
          and plan ahead for emergency events with indoor mapping software.
          During an emergency, people are able to quickly find their way out of
          the building with the best possible exit routes. By implementing
          indoor positioning for your business, facility managers can accurately
          and visually analyze facilities to increase productivity and
          efficiency.
        </span>
      </>
    ),
  },
  {
    title: "Why should I implement a digital indoor map at my venue?",
    text: (
      <>
        <span>
          Some indoor maps are simply static images of the venue. With digital
          indoor mapping solutions, you get more effective and interactive
          experience. Mappedin allows for accuracy in your datasets, precision
          in your maps, and ease of use for both the map editor and the end
          user. Our mapping tools give businesses the ability to make edits and
          updates to their venues in just a few clicks and Mappedin’s
          enterprise-grade tools make collaboration across different teams and
          companies easier with permission access levels. For facility managers
          looking to update directories or control crowd control for shoppers,
          headquarters can provide an access level that gives local managers the
          ability to make revisions on their own. For large healthcare
          institutions, precision is extra important to help with hospital
          wayfinding and leading both patients and staff to find the right
          building and room.{" "}
        </span>
        <span>
          Digital maps of your venue can also take advantage of indoor
          positioning to show a user’s precise location. With blue dot
          positioning, visitors can view accurate turn-by-turn directions to
          various points of interests. When paired with a digital map, indoor
          positioning can also unlock various other IoT solutions.
        </span>
      </>
    ),
  },
  {
    title:
      "What are the advantages of Mappedin vs using other mapping platforms?",
    text: (
      <>
        <span>
          Whether you’re looking to implement indoor maps on your existing web
          app or creating a new application for your venue, Mappedin’s flexible
          platform enables businesses to build mapping solutions and apps that
          can truly integrate with your property. Businesses can easily upload
          information to the map while customizing points of interest in
          directories. Our software suite also helps businesses to bring
          together 2D maps and 3D visualizations to create robust indoor 3D
          maps. Our innovative system creates accurate 3D models of your
          buildings - both inside and out.
        </span>
        <span>
          Mappedin’s CMS also gives a central management location for all of
          your data sources. It allows for tying data to real world geometry and
          provides an export of real GIS data. This allows for extremely
          accurate location data and unlocks powerful integrations with
          technology such as an indoor positioning system.
        </span>
        <span>
          Mappedin has extensive experience working with venues in different
          verticals. We’ve helped a wide range of clients, such as malls,
          stadiums, retail stores, offices, , university campuses, and other
          large venues leverage indoor maps to manage their indoor space. For
          example, universities can create 3D campus maps to provide a realistic
          view of their campuses, allowing visitors to interact and engage with
          the map. We’ve also helped stadiums leverage a navigation application
          compatible with IPS to assist with routing guests from their parking
          space to their seat section in the arena. Many large venues add
          digital signage to their space as a centerpiece. These solutions allow
          map users to find out all the information they need about the venue,
          including categories, directions, and further detail on various
          vendors.
        </span>
      </>
    ),
  },
]

export default function IndoorMappingFAQ() {
  return <FAQ title="Indoor Mapping Software FAQs" items={FAQItems} />
}
